<template>
    <div>
        <el-dialog v-model="dialogVisible"  
     
         class="custom-dialog"
        :before-close="handleClose"
        center>
           
        <h3 style="text-align: center; color: #fff; font-size: 18px ">{{loadingTitle}}</h3>
            <el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right" label-width="auto" style="margin-top: 30px;">
                <el-form-item label="设备名称:" prop="name" class="form-input_class">
                    <el-input v-model.trim="formData.name" maxlength="30"  class="form-input_class1" placeholder="设备名称" ></el-input>
                </el-form-item>
                <el-form-item label="分厂:" prop="branch_factory" class="form-input_class">
                    <el-select v-model="formData.branch_factory" placeholder="分厂" size="default" clearable   class="form-input_class1">
                        <el-option
                                v-for="item in branchFactoryList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工段:" prop="workshop_section" class="form-input_class">
                    <el-input v-model.trim="formData.workshop_section" maxlength="30" placeholder="工段" class="form-input_class1"></el-input>
                </el-form-item>
                <el-form-item  label="设备编号:" prop="device_sn" class="form-input_class">
                    <el-input v-model.trim="formData.device_sn" maxlength="30" placeholder="设备编号" class="form-input_class1"></el-input>
                </el-form-item>
                <el-form-item  label="传感器ID:" prop="sensor_sn" class="form-input_class">
                    <el-input v-model.trim="formData.sensor_sn" maxlength="30"  placeholder="传感器ID" class="form-input_class1"></el-input>
                </el-form-item>
            </el-form>
            <el-col :span="24" style="text-align: center; height: 30px; margin-top: 15px;margin-bottom: 40px;">
                <el-button type="primary" @click="submitData" :loading="loadingSave" style="width: 100px;">确定</el-button>
                <el-button @click="handleClose" style="color: black;width: 100px;">取消</el-button>
            </el-col>
           
           
         

        </el-dialog>
    </div>
</template>

<script>
    import {apiDeviceCreateExtra1} from "@/api/api";
    import LyDialog3 from "@/components/dialog/dialog3";
    import XEUtils from "xe-utils";
    import {deepClone} from "@/utils/util";
    import deviceTypeConfig from "@/config"

    export default {
        components: {LyDialog3},
        emits: ['refreshData'],
        name: "addDevice",
        data() {
            return {
                dialogVisible:false,
                loadingSave:false,
                loadingTitle:'',
                formData:{
                    name:'',
                    workshop_section:'',
                    location:'',
                    sensor_sn:'',
                    device_sn:'',
                    branch_factory:null,
                    stopped_threshold:0.2,
                    warning_alarm_threshold:4.5,
                    fatal_alarm_threshold:7.1,
                    sensor_type:1,
                  
                },
                rules:{
                    name: [
                        {required: true, message: '请输入设备名称',trigger: 'blur'}
                    ],
                    branch_factory: [
                        {required: true, message: '请输入分厂',trigger: 'blur'}
                    ],
                    workshop_section: [
                        {required: true, message: '请输入工段',trigger: 'blur'}
                    ],
                    location: [
                        {required: true, message: '请输入传感器测点',trigger: 'blur'}
                    ],
                    device_sn: [
                        {required: true, message: '请输入设备编码',trigger: 'blur'}
                    ],
                   sensor_sn: [
                        {required: true, message: '请输入传感器ID',trigger: 'blur'}
                    ],
                    stopped_threshold:[
                        {required: true, message: '请输入停机阈值 单位mm/s',trigger: 'blur'}
                    ],
                    warning_alarm_threshold:[
                        {required: true, message: '请输入轻微报警阈值 单位mm/s',trigger: 'blur'}
                    ],
                    fatal_alarm_threshold:[
                        {required: true, message: '请输入严重报警阈值 单位mm/s',trigger: 'blur'}
                    ],
                    // rated_current:[
                    //     {required: true, message: '请输入额定电流 单位A',trigger: 'blur'}
                    // ],
                    sensor_type: [
                        {required: true, message: '请输入传感器类型',trigger: 'blur'}
                    ]
                },
                rolelist:[],
                options:[],
                branchFactoryList:[
                    {id:1,name:deviceTypeConfig.DEVICE_TYPE_1},
                    {id:2,name:deviceTypeConfig.DEVICE_TYPE_2},
                    {id:3,name:deviceTypeConfig.DEVICE_TYPE_3},
                    {id:4,name:deviceTypeConfig.DEVICE_TYPE_4},
                    {id:5,name:deviceTypeConfig.DEVICE_TYPE_5},
                    {id:6,name:deviceTypeConfig.DEVICE_TYPE_6},
                ],
                sensorTypeList:[
                    {id:0,name:"单轴振动传感器"},
                    {id:1,name:"三轴振动传感器"},
                    {id:2,name:"电流传感器"},
                ]
            }
        },
        methods:{
            handleClose() {
                this.dialogVisible=false
                this.loadingSave=false
                this.formData = {
                    name:'',
                    group_name:'',
                    location:'',
                    sensor_sn:'',
                    device_sn:'',
                    type:''
                }
            },
            addDeviceFn(item,flag) {
                this.loadingTitle=flag
                this.dialogVisible=true

                if(item){
                    this.formData = deepClone(item)
                }

                this.formData.stopped_threshold = 0.2,
                this.formData.warning_alarm_threshold = 4.5,
                this.formData.fatal_alarm_threshold = 7.1
            },
            getBranchFactory(factory){
                switch(factory){
                    case 1: return this.branchFactoryList[0].name;
                    case 2: return this.branchFactoryList[1].name;
                    case 3: return this.branchFactoryList[2].name;
                    case 4: return this.branchFactoryList[3].name;
                    case 5: return this.branchFactoryList[4].name;
                    case 6: return this.branchFactoryList[5].name;
                    default :return "未知分厂";
                }
            },
            submitData() {
                this.$refs['rulesForm'].validate(obj=>{
                    if(obj) {
                        this.loadingSave=true 
                        let parm_device = {
                            workshop_section: this.formData.workshop_section,
                            branch_factory:this.getBranchFactory(this.formData.branch_factory),
                            device_name: this.formData.name,
                            device_type: 1,
                            sensor_sn: this.formData.sensor_sn,
                            device_sn:this.formData.device_sn,
                            sensor_name: '1v', 
                            stopped_threshold : this.formData.stopped_threshold,
                            warning_alarm_threshold : this.formData.warning_alarm_threshold,
                            fatal_alarm_threshold : this.formData.fatal_alarm_threshold,
                            sensor_type : this.formData.sensor_type == 2 ? 2 : 1 ,
                            axis_type : this.formData.sensor_type == 2 ? 1 : this.formData.sensor_type == 1 ? 3 : 1,
                            device_group_name : "内蒙古宜化化工有限公司"
                            // rated_current : this.formData.rated_current
                        }
                        apiDeviceCreateExtra1(parm_device).then(res=>{
                            this.loadingSave=false
                            if(res.data.code ==201) {
                                this.$message.success("创建成功")
                                this.handleClose()
                                this.$emit('refreshData')
                            } else {
                                if(res.data.msg)
                                    this.$message.warning(`设备创建失败 : ${res.data.msg}`)
                            }
                        }) .catch(res => {  
                            this.loadingSave=false
                            this.$message.warning(`设备创建失败 : ${res.msg}`)
                        });
                    }
                })
            },
        }
    }
</script>

<style lang="scss"  scoped >

 :deep(.custom-dialog)  {
 
    width: 600px;
    
    background: url("@/assets/bigscreen/alarm_handle.png") no-repeat center center;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
   

 }
:deep(.el-input__wrapper){
    background-color: #fff;
   
}
:deep(.el-input__inner){
    color: black;
   
}

.form-input_class1{
  
 
    width:400px;
}



.form-input_class{
    margin-top:10px ;
    margin-left: auto;
    margin-right: auto;
    width:480px;
  
    
}

</style>